import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FilterViewModel } from '../models/view-model';

@Injectable({
  providedIn: 'root'
})
export class FilterControlService {

  constructor(private fb: FormBuilder) {
  }

  filtersToFormGroup(filters: FilterViewModel[]) {
    const array = this.fb.array<ReturnType<typeof this.filterToFormGroup>>([]);
    filters.forEach((filter) => {
      array.push(this.filterToFormGroup(filter));
    });
    return array;
  }

  filterToFormGroup(filter: FilterViewModel): FormGroup<any> {
    return this.fb.group({
      field: filter.field,
      operator: filter.operator,
      logicalOperator: filter.logicalOperator,
      filterType: filter.filterType,
      cvFilterModel: filter.cvFilterModel,
      values: filter.values
    });
  }

  formGroupToFilter(filterGroup): FilterViewModel {
    const filterRaw = filterGroup.getRawValue();
    return new FilterViewModel(
      filterRaw.field,
      filterRaw.operator,
      filterRaw.values,
      filterRaw.logicalOperator,
      filterRaw.filterType
    );
  }
}
